import styled, { css } from 'styled-components';

import { darken } from 'polished';

const colors = {
  primary: css`
    border: 1px solid
      ${props => darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    color: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    background: transparent;
  `,
  secondary: css`
    color: #fff;
    background: ${props => (props.theme.color ? props.theme.color : '#0052CC')};
    /* background: #0052CC 0% 0% no-repeat padding-box; */
    width: 8.5rem;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right: 1.3rem;
    padding-left: 0.4rem;
  `,
  normal: css`
    color: #fff;
    background: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
  `,
  pcd: css`
    color: #fff;
    background: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    font-weight: normal;
    width: 5rem;
    padding: 0.2rem 0;
  `,
  pcd_d: css`
    color: #fff;
    background: ${props => (props.theme.color ? props.theme.color : '#0052CC')};
    width: 93px;
    font: 16px/28px;
    margin-left: 14px;

    span {
      color: #fff;
    }
  `,
  apply_small: css`
    color: #fff;
    background: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    width: 8.5rem;
    font-size: 17px;
    width: 100%;
    height: 30px;
    padding: 0.3rem 0;

    span {
      font-size: 16px;
    }
  `,
  error: css`
    color: #fff;
    background: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    width: 8.5rem;
    font-size: 17px;
    width: 100%;
    height: 30px;
    padding: 0.3rem 0;
    margin-top: 60px;

    span {
      font-size: 16px;
    }
  `,

  detail: css`
    color: #fff;
    background: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    width: 9.5rem;
    font-size: 17px;
    padding: 0.5rem 0;
  `,
  apply_big: css`
    color: #fff;
    background: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    width: 15.5rem;

    height: 40px;
    padding: 0.5rem 0;
    margin-right: 18px;

    span {
      font-size: 16px;
    }
  `,
  return_big: css`
    border: 1px solid
      ${props => darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    color: ${props =>
      darken(0.1, props.theme.color ? props.theme.color : 'blue')};
    background: transparent;
    /* width: 10.5rem; */
    width: 236px;
    height: 40px;
    font-size: 42px;
    padding: 0.5rem 0;
  `,
  share: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 7px;
    cursor: default;

    background: #ebecf0 0% 0% no-repeat padding-box;
    opacity: 1;
    width: 176px;
    height: 30px;

    span {
      font: Regular 12px/32px Roboto;
      color: #42526e;
      opacity: 1;
    }

    padding: 0.3rem;
  `,
  share_responsive: css`
    opacity: 1;
    width: 100%;
    height: 60px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin-top: 7px;
    cursor: pointer;
    margin-left: 6px;

    span {
      font: Regular 12px/32px Roboto;
      color: #42526e;
      opacity: 1;
    }
  `,
};

export const Button = styled.button`
  border-radius: 3px;
  padding: 0.3rem 0;
  width: 7rem;

  cursor: pointer;

  border: 0;

  ${props => colors[props.color]}
  font-size:10px;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: default;

    &:hover {
      opacity: 0.5;
      cursor: default;
    }
  }

  p {
    margin-left: 14px;
  }
`;
